import { GraduationCap } from "lucide-react";
import Link from "next/link";
import { cn } from "@/lib/utils";

interface HRDCorpBadgeProps {
  readonly variant?: "hero" | "compact" | "card";
  readonly className?: string;
}

export function HRDCorpBadge({
  variant = "compact",
  className
}: HRDCorpBadgeProps) {
  const badgeContent = (
    <>
      {variant === "hero" && (
        <Link
          href="/services/training-education"
          className={cn(
            "group inline-flex items-center gap-2.5 rounded-xl bg-white/90 backdrop-blur-sm px-3 py-1.5 shadow-md border border-gray-100/50 hover:bg-white hover:shadow-lg hover:scale-[1.01] transition-all duration-200 cursor-pointer",
            className
          )}
        >
          <img
            src="/images/hrd-corp-badge.png"
            alt="HRD Corp Registered Training Provider"
            className="h-9 w-9 object-contain group-hover:scale-105 transition-transform duration-200"
          />
          <div className="flex flex-col leading-none">
            <span className="text-xs font-semibold text-gray-800">
              HRD Corp Approved
            </span>
            <span className="text-[10px] text-gray-500">
              Training Provider
            </span>
          </div>
        </Link>
      )}

      {variant === "compact" && (
        <span className={cn(
          "inline-flex items-center gap-2 rounded-full bg-primary/25 px-4 py-2 text-sm font-semibold text-primary-contrast",
          className
        )}>
          <GraduationCap className="size-4" aria-hidden />
          HRD Corp Registered
        </span>
      )}

      {variant === "card" && (
        <div className={cn(
          "rounded-2xl bg-gradient-to-br from-slate-50 to-blue-50 p-6 text-center shadow-md border border-slate-100",
          className
        )}>
          <img
            src="/images/hrd-corp-badge.png"
            alt="HRD Corp Registered Training Provider"
            className="mx-auto mb-4 h-24 w-24 object-contain"
          />
          <h3 className="mb-2 text-sm font-bold text-gray-900">
            HRD Corp Registered
          </h3>
          <p className="text-sm text-gray-600">
            Eligible for HRD Corp levy approved training programmes
          </p>
        </div>
      )}
    </>
  );

  return badgeContent;
}
